import { schema } from "normalizr";
export const board = new schema.Entity("board");
export const boardsSchema = new schema.Entity("boards", {
  boards: [board]
});
export const collaborator = new schema.Entity("collaborator");
export const collaboratorsSchema = new schema.Entity("collaborators", {
  collaborators: [collaborator]
}, {
  idAttribute: "username"
});
export const clientProfile = new schema.Entity("clientProfile");
export const clientProfileSchema = new schema.Entity("clientProfiles", {
  clientProfiles: [clientProfile]
});
export const statistics = new schema.Entity("statistics");
export const statisticSchema = new schema.Entity("statistics", {
  statistics: [statistics]
});
export const customField = new schema.Entity("customField");
export const customFieldsSchema = new schema.Entity("customFields", {
  customField: [customField]
});
export const subscriber = new schema.Entity("subscriber");
export const subscribersSchema = new schema.Entity("subscribers", {
  subscribers: [subscriber]
}, {
  idAttribute: "subscriberId"
});
export const inactiveClient = new schema.Entity("inactiveClient");
export const inactiveClientSchema = new schema.Entity("inactiveClient", {
  inactiveClientProfiles: [inactiveClient]
});
export const emailTemplate = new schema.Entity("emailTemplate");
export const emailTemplatesSchema = new schema.Entity("emailTemplates", {
  emailTemplates: [emailTemplate]
});
export const checklistTemplate = new schema.Entity("checklistTemplate");
export const checklistTemplatesSchema = new schema.Entity("checklistTemplates", {
  checklistTemplates: [checklistTemplate]
});
export const timelineItem = new schema.Entity("timelineItem");
export const timelineSchema = new schema.Entity("timeline", {
  timelines: [timelineItem]
});